import get from 'lodash/get';
import { useSelector } from 'react-redux';

import isEmpty from 'lodash/isEmpty';
import { PROVIDERS, PROVIDER_ALL } from '../constants';
import {
  loggedUserSelector,
  targetUserSelector,
} from '../../../../redux/context/selectors';

const {
  CCD,
  DEVICES,
  LOCAL,
  APPLE,
  FITBIT,
  WITHINGS,
  GOOGLE_FIT,
  TENOVI,
  I_HEALTH,
} = PROVIDERS;

export const useChartFormats = ({ formatMessage }) => {
  const loggedUser = useSelector(loggedUserSelector);
  const targetUser = useSelector(targetUserSelector);
  const isMeNotTargetUser =
    loggedUser.id !== targetUser.id && !isEmpty(targetUser);
  const name = get(targetUser, 'firstName', '');

  const concatWithName = device => {
    if (isMeNotTargetUser) {
      return `${name}'s ${device}`;
    }
    return device;
  };

  return {
    [PROVIDER_ALL]: formatMessage({ id: 'patient.healthboard.allSources' }),
    [CCD]: formatMessage({ id: 'patient.healthboard.ccd' }),
    [DEVICES]: isMeNotTargetUser
      ? formatMessage({ id: 'patient.healthboard.userDevices' }, { name })
      : formatMessage({ id: 'patient.healthboard.myDevices' }),
    [LOCAL]: concatWithName(formatMessage({ id: 'patient.healthboard.local' })),
    [APPLE]: concatWithName(formatMessage({ id: 'patient.healthboard.apple' })),
    [FITBIT]: concatWithName(
      formatMessage({ id: 'patient.healthboard.fitbit' }),
    ),
    [WITHINGS]: concatWithName(
      formatMessage({ id: 'patient.healthboard.withings' }),
    ),
    [GOOGLE_FIT]: concatWithName(
      formatMessage({ id: 'patient.healthboard.googleFit' }),
    ),
    [TENOVI]: concatWithName(
      formatMessage({ id: 'patient.healthboard.tenovi' }),
    ),
    [I_HEALTH]: concatWithName(
      formatMessage({ id: 'patient.healthboard.iHealth' }),
    ),
  };
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/hooks/useChartFormats.js